import { useCurrentCurrency } from "../../hooks/useCurrentCurrency";
import { coerceSupportedCurrency } from "../../lib/currency";

export const CurrencySelect = () => {
  const { currency, setCurrency } = useCurrentCurrency();

  return (
    <select
      value={currency}
      onChange={(e) => setCurrency(coerceSupportedCurrency(e.target.value))}
      className="h-9 rounded-lg border border-gray-200 bg-gray-50 px-3 text-sm font-medium text-gray-900 outline-none transition-colors hover:bg-gray-100 focus:ring-2 focus:ring-blue-500"
      aria-label="Display currency"
    >
      <option value="USD">USD</option>
      <option value="ILS">ILS</option>
      <option value="EUR">EUR</option>
    </select>
  );
};
